















import moment from 'moment'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import { SelectOption } from '../../../../../logic/types'
import { UseFields } from '../../../../Pi'
import { ConditionMode } from '../../types'
import DateTimeValueConditions from '../components/DateTimeValueConditions.vue'
import LessGreaterConditionMode from '../components/LessGreaterConditionMode.vue'
import { ActivityCondition } from '../types'

@Component({
  components: {
    LessGreaterConditionMode,
    DateTimeValueConditions
  }
})
export default class DistributionActivityCondition extends Mixins(UseFields, ModelSetter) {
  @VModel({ type: Object, required: true }) condition!:ActivityCondition

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  MONTH_BEFORE = moment().add(-1, 'month').format('YYYY-MM-DD HH:mm:ss')

  YEAR_BEFORE = moment().add(-1, 'year').format('YYYY-MM-DD HH:mm:ss')

  get modePostfix() {
    if (this.condition.mode === ConditionMode.Less) {
      return 'less'
    } else if (this.condition.mode === ConditionMode.Greater) {
      return 'greater'
    } else {
      return ''
    }
  }

  get dateTimeValueOptions(): Array<SelectOption> {
    return [
      { value: null,              label: this.$t(`option_activity_all_${ this.modePostfix }`).toString() },
      { value: this.MONTH_BEFORE, label: this.$t(`option_activity_month_before_${ this.modePostfix }`).toString() },
      { value: this.YEAR_BEFORE,  label: this.$t(`option_activity_year_before_${ this.modePostfix }`).toString() },
      { value: 'Custom',          label: this.$t(`option_activity_custom_${ this.modePostfix }`).toString() },
    ]
  }
}
